
/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { takeLatest, select, put } from 'redux-saga/effects';
import { push } from '@nebula/rover';
import { NAVIGATE_TO_SESSION_LIST } from '../../common/actions';
import { ROVER_MAP } from '../data/routes';

const injectVarsInRoute = (route, payload = {}) =>
  route.split('/').map(item =>
    (item.substr(0, 1) === ':'
      ? payload[item.substr(1)] || item : R.match(/\(.*\)/, item).length ? '' : item)).join('/');

export function* injectVarsAndRoute(action) {
  const config = ROVER_MAP[action.type];
  let url = injectVarsInRoute(config.url, action.payload);

  if (action.type !== NAVIGATE_TO_SESSION_LIST && url.indexOf('#') < 0) {
    const hash = yield select(R.path(['router', 'hash']));
    url = `${url}${hash || ''}`;
  }
  yield put(push(url));
}

export function* watchMappedRoutesSaga() {
  yield takeLatest(R.keys(ROVER_MAP), injectVarsAndRoute);
}
